const HEALTHOS_ROLE = "user:healthos";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function stringValues(value: unknown): string[] {
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : [];
}

function accessTokenClaims(accessToken: string | null | undefined): Record<string, unknown> | null {
  if (!accessToken) return null;
  const payload = accessToken.split(".")[1];
  if (!payload) return null;

  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const claims: unknown = JSON.parse(atob(padded));
    return isRecord(claims) ? claims : null;
  } catch {
    return null;
  }
}

/**
 * The API remains the authorization boundary. This client-side read simply
 * prevents a person from entering onboarding with a token the API will reject.
 */
export function hasHealthosAccess(accessToken: string | null | undefined): boolean {
  const claims = accessTokenClaims(accessToken);
  if (!claims) return false;

  const realmAccess = isRecord(claims.realm_access) ? claims.realm_access : null;
  const roles = new Set([...stringValues(realmAccess?.roles), ...stringValues(claims.thriveRoles)]);
  return roles.has(HEALTHOS_ROLE);
}

const CONTACT_CENTRE_ROLES = new Set([
  "user:healthos:contact-centre",
  "contact-centre",
  "contact_centre",
]);

export function hasContactCentreRole(roles: readonly string[]): boolean {
  return roles.some((role) => CONTACT_CENTRE_ROLES.has(role));
}
